import React from "react";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import AddIcCallIcon from "@mui/icons-material/AddIcCall";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import DirectionsIcon from "@mui/icons-material/Directions";
import "./Footer.css";

function Footer() {
  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <footer className="ft-footer">
      {/* Thin green accent strip at the very top */}
      <div className="ft-footer__strip" />

      {/* ── Main grid ─────────────────────────────────── */}
      <div className="ft-footer__main">
        <div className="container">
          <div className="ft-footer__grid">

            {/* ── Col 1: Useful Links ─────────────────── */}
            <div className="ft-col">
              <h1 className="ft-col__heading">Useful Links</h1>
              <hr className="ft-col__rule" />
              <a className="ft-link" href="https://cleancooking.org/" target="_blank" rel="noopener noreferrer">
                The Clean Cooking Alliance
              </a>
              <a className="ft-link" href="https://unbs.go.ug/" target="_blank" rel="noopener noreferrer">
                Uganda National Bureau of Standards
              </a>
              <a className="ft-link" href="https://mecs.org.uk/" target="_blank" rel="noopener noreferrer">
                Modern Energy Cooking Services (MECS)
              </a>
              <a className="ft-link" href="https://www.psfuganda.org/" target="_blank" rel="noopener noreferrer">
                Private Sector Foundation Uganda (PSFU)
              </a>
              <a className="ft-link" href="https://memd.go.ug/" target="_blank" rel="noopener noreferrer">
                Ministry of Energy and Mineral Development
              </a>
            </div>

            {/* ── Col 2: Quick Links ──────────────────── */}
            <div className="ft-col">
              <h1 className="ft-col__heading">Quick Links</h1>
              <hr className="ft-col__rule" />
              <Link className="ft-link" to="/" onClick={scrollToTop}>Home</Link>
              <Link className="ft-link" to="/about-us/what-we-do" onClick={scrollToTop}>What We Do</Link>
              <Link className="ft-link" to="/the-team/the-staff-team" onClick={scrollToTop}>The Staff Team</Link>
              <Link className="ft-link" to="/publicity/news-and-events" onClick={scrollToTop}>News &amp; Events</Link>
              <Link className="ft-link" to="/our-services/cookstoves-and-fuel-testing" onClick={scrollToTop}>
                Cookstoves &amp; Fuel Testing
              </Link>
            </div>

            {/* ── Col 3: Social Media ─────────────────── */}
            <div className="ft-col">
              <h1 className="ft-col__heading">Social Media</h1>
              <hr className="ft-col__rule" />
              <div className="ft-social-list">
                <a className="ft-social-link ft-social-link--twitter"
                  href="https://twitter.com/CIRCODU1" target="_blank" rel="noopener noreferrer">
                  <XIcon /> Twitter / X
                </a>
                <a className="ft-social-link ft-social-link--linkedin"
                  href="https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu"
                  target="_blank" rel="noopener noreferrer">
                  <LinkedInIcon /> LinkedIn
                </a>
                <a className="ft-social-link ft-social-link--youtube"
                  href="https://youtube.com/@CIRCODU" target="_blank" rel="noopener noreferrer">
                  <YouTubeIcon /> YouTube
                </a>
                <a className="ft-social-link ft-social-link--facebook"
                  href="https://www.facebook.com/Circodu/" target="_blank" rel="noopener noreferrer">
                  <FacebookOutlinedIcon /> Facebook
                </a>
                <a className="ft-social-link ft-social-link--whatsapp"
                  href="https://wa.me/256782433627" target="_blank" rel="noopener noreferrer">
                  <WhatsAppIcon /> WhatsApp
                </a>
              </div>
            </div>

            {/* ── Col 4: Contact Us ───────────────────── */}
            <div className="ft-col">
              <h1 className="ft-col__heading">Contact Us</h1>
              <hr className="ft-col__rule" />
              <a className="ft-link" href="tel:+256392004309">
                <CallIcon /> +256 392 004 309
              </a>
              <a className="ft-link" href="tel:+256782433627">
                <AddIcCallIcon /> +256 782 433 627
              </a>
              <a className="ft-link" href="mailto:info@circodu.org.ug" target="_blank" rel="noopener noreferrer">
                <EmailIcon /> info@circodu.org.ug
              </a>
              <a className="ft-link" href="https://goo.gl/maps/ZmZM5rhrpHyFPhSu5" target="_blank" rel="noopener noreferrer">
                <DirectionsIcon /> Get Directions
              </a>
              <div className="ft-addr">
                <HomeIcon /> P.O. Box 16340, Wandegeya, Kampala
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── Bottom bar ────────────────────────────────── */}
        <div className="ft-footer__bar">
        <div className="container">
          <div className="ft-footer__bar-inner">
            <a className="ft-bar__item" href="/" onClick={scrollToTop}>
              Centre for Integrated Research &amp; Community Development Uganda
            </a>
            <span className="ft-bar__sep">|</span>
            <span className="ft-bar__item">
              <b>All Rights Reserved. CIRCODU © 2007 – 2026</b>
            </span>
            <span className="ft-bar__sep">|</span>
            <a className="ft-bar__item" href="https://wa.me/256785430302" target="_blank" rel="noopener noreferrer">
              Designed by: e-Solutions Inc Uganda
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;